import { useState } from 'react';
import { resolutionHeader } from 'src/Tenants';
import JuniperInsightsSkeleton from './JuniperInsightsSkeleton/JuniperInsightsSkeleton';
import './LLMContainer.scss';

export const LLMContainer = () => {
  const [isFrameLoaded, setIsFrameLoaded] = useState<boolean>(false);

  const authToken = JSON.parse(localStorage.getItem('auth'));
  const tenantId = resolutionHeader;

  const env = import.meta.env.VITE_ENVIRONMENT;

  const JUNIPER_LLM_STAGING_URL = 'https://llm.staging.juniper.re';
  const JUNIPER_LLM_PROD_URL = 'https://llm.live.juniper.re';

  const baseUrl = ['dev', 'staging'].includes(env)
    ? JUNIPER_LLM_STAGING_URL
    : JUNIPER_LLM_PROD_URL;

  return (
    <div className="llm-container">
      <iframe
        src={`${baseUrl}?authToken=${authToken}&tenantId=${tenantId}`}
        width="100%"
        height="500"
        loading="lazy"
        onLoad={() => setIsFrameLoaded(true)}
        className="llm-frame"
        frameBorder={'0'}
      />

      {!isFrameLoaded && (
        <div className="llm-container-skeleton-overlay">
          <JuniperInsightsSkeleton />
        </div>
      )}
    </div>
  );
};